import axiosClient from "../axios/axiosClient";

export function getAccreditingBodies() {
  return axiosClient.get("/accrediting-bodies");
}

export function getAccreditingBody(accreditingBodyId) {
  return axiosClient.get(`/accrediting-bodies/${accreditingBodyId}`);
}

export function createAccreditingBody(data) {
  return axiosClient.post("/accrediting-bodies", data);
}

export const updateAccreditingBody = (accreditingBodyId, data) => {
  return axiosClient.put(`/accrediting-bodies/${accreditingBodyId}`, data);
};

export function deleteAccreditingBody(accreditingBodyId) {
  return axiosClient.delete(`/accrediting-bodies/${accreditingBodyId}`);
}
